export default class LimitWarning extends React.PureComponent
  constructor: (props) ->
    super(props)

  limitedDuration: ->
    switch @props.limitWarningCode
      when 'user_limit'
        @props.limitedDurations.user
      when 'ip_limit'
        @props.limitedDurations.ip
      when 'session_limit'
        @props.limitedDurations.session

  render: ->
    isCharLimit  = @props.limitWarningCode.endsWith('_char')
    isUsageLimit = @props.limitWarningCode.endsWith('_limit')

    # We receive snake-cased values ('pro_char', 'ip_limit'), but we need them camelized ('proChar', 'ipLimit') for localization
    i18n = @props.i18n[humps.camelize(@props.limitWarningCode)]

    text = i18n.text
    text = text.replace('%{max_number}', @props.charLimit) if isCharLimit

    classes = "alert-limit"
    classes += " alert-limit-visitor"    if !@props.currentUser
    classes += " alert-limit-free-user"  if @props.currentUser?.isFree
    classes += " alert-limit-pro-user"   if @props.currentUser?.isPro
    classes += " alert-limit-no-targets" if !@props.targets.length

    <div className={classes} role="alert">
      <p>
        {text}
      </p>

      { @renderComeBack() if isUsageLimit }

      { @renderCustomCta(i18n.cta) if i18n.cta }

      { @renderContactButton() if @props.currentUser?.isPro  }
      { @renderUpgradeCard()   if @props.currentUser?.isFree }
      { @renderSignUpButtons() if !@props.currentUser       }
    </div>

  renderComeBack: ->
    i18n = @props.i18n.comeBack
    
    # Working from milliseconds to minutes and hours
    msLeft      = @limitedDuration() - (Date.now() - @props.lastLimitedAt)
    msLeft      = Math.max(0, msLeft)
    minutesLeft = Math.ceil(msLeft / 60000) # round up total minutes

    key = if minutesLeft == 1 then 'minute' else 'minutes'

    <p className="come-back">
      { i18n.text }
      <span className="minutes">
        { i18n[key].replace('%{count}', minutesLeft) }
      </span>
    </p>

  renderCustomCta: (cta) ->
    <>
      <hr />
      <p className="cta">
        { cta }
      </p>
    </>

  renderUpgradeCard: ->
    i18n = @props.i18n.upgradeCard

    <div className="card plan-card">
      <div className="card-body gradient-background">
        <h4>
          { i18n.title }
        </h4>

        <p className="with">
          { i18n.with }
        </p>
        
        <ul className="advantages">
          <li>
            <i className="far fa-circle-check" />
            { i18n.unlimitedUsage }
          </li>
          <li>
            <i className="far fa-circle-check" />              
            { i18n.dataPrivacy }
          </li>
          <li>
            <i className="far fa-circle-check" />
            { i18n.translationQuality }
          </li>
          <li>
            <i className="far fa-circle-check" />
            { i18n.longerTexts }
          </li>
        </ul>
        
        <button className="btn btn-primary btn-upgrade rounded-pill"
                onClick={@props.openCheckoutModal}>
          {@props.i18n.upgrade}
        </button>

        <a href="#"
           className="view-plans-link"
           onClick={@props.scrollToPricing.bind(this, 'limit')}>
          {@props.i18n.viewPlans}
        </a>
      </div>
    </div>

  renderContactButton: ->
    <a href="mailto:contact@neurooo.com" target="_blank"
       className="btn btn-primary rounded-pill">
      {@props.i18n.contactUs}
    </a>

  renderSignUpButtons: ->
    <div className="signup-buttons">
      <div className="oauth-buttons">
        <a href={@props.paths.googleSignUpPath} data-method="post" rel="nofollow" className="btn btn-google-outline">
          <img src={@props.assets.googleOauthIcon} />
          {@props.i18n.signUpWithGoogle}
        </a>
      </div>
      <span>
        {@props.i18n.or}
        {' '}
        <a href={@props.paths.signUpPath}>
          {@props.i18n.signUpWithEmail}
        </a>
      </span>
    </div>
